import ScrollReveal from "./ScrollReveal";

interface LegalItem {
  label: string;
  value: string;
}

interface LegalSectionProps {
  title: string;
  items: LegalItem[];
  index: number;
  variant?: "default" | "bordered";
}

export default function LegalSection({
  title,
  items,
  index,
  variant = "default",
}: LegalSectionProps) {
  const bgClass =
    variant === "bordered"
      ? "bg-white border border-airdoa-gray-light/50 rounded-lg overflow-hidden"
      : "bg-white border border-airdoa-gray-light/50 rounded-lg overflow-hidden";

  return (
    <ScrollReveal direction="up" delay={index * 60}>
      <div>
        <h2 className="text-base md:text-lg font-serif font-semibold text-airdoa-navy mb-4 flex items-center gap-2.5">
          <span className="w-1 h-5 bg-airdoa-gold rounded-full shrink-0" />
          {title}
        </h2>
        <div className={bgClass}>
          <table className="w-full text-sm">
            <tbody>
              {items.map((item, idx) => (
                <tr
                  key={item.label}
                  className={
                    idx % 2 === 0
                      ? "bg-transparent"
                      : "bg-airdoa-cream/50"
                  }
                >
                  <th className="px-4 md:px-5 py-3.5 md:py-4 text-left text-xs font-medium text-airdoa-gray w-[35%] md:w-[30%] align-top border-b border-airdoa-gray-light/30">
                    {item.label}
                  </th>
                  <td className="px-4 md:px-5 py-3.5 md:py-4 text-sm text-airdoa-navy leading-relaxed border-b border-airdoa-gray-light/30">
                    {item.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </ScrollReveal>
  );
}